import type { Exercise } from "../types";

export const exploradorExercises: Exercise[] = [
  {
    id: "ex-01",
    levelId: "explorador",
    order: 1,
    title: "Tres Cuerdas Agudas",
    subtitle: "Conquista el territorio Sol-Si-Mi (cuerdas 1-2-3)",
    category: "notas",
    difficulty: "facil",
    type: "click",
    methodRef: "Cap. V - Notas naturales en las tres primeras cuerdas (Ej. 13-22)",
    description:
      "Las tres cuerdas agudas son el territorio de la melodia. Este ejercicio te hace cartografiar cada nota natural en estas cuerdas, de la posicion abierta al traste III.",
    instructions: [
      "Encuentra las notas naturales en las cuerdas 1, 2 y 3.",
      "Usa digitacion con dedos fijos (1=traste I, 2=traste II, 3=traste III).",
      "Haz clic en cada nota solicitada.",
    ],
    steps: [
      { id: 1, instruction: "Encuentra Mi en cuerda 1 (al aire)", positions: [{ string: 1, fret: 0 }], answers: ["Mi"] },
      { id: 2, instruction: "Encuentra Sol en cuerda 1 (traste III)", positions: [{ string: 1, fret: 3 }], answers: ["Sol"] },
      { id: 3, instruction: "Encuentra Si en cuerda 2 (al aire)", positions: [{ string: 2, fret: 0 }], answers: ["Si"] },
      { id: 4, instruction: "Encuentra Do en cuerda 2 (traste I)", positions: [{ string: 2, fret: 1 }], answers: ["Do"] },
      { id: 5, instruction: "Encuentra Re en cuerda 2 (traste III)", positions: [{ string: 2, fret: 3 }], answers: ["Re"] },
      { id: 6, instruction: "Encuentra Sol en cuerda 3 (al aire)", positions: [{ string: 3, fret: 0 }], answers: ["Sol"] },
      { id: 7, instruction: "Encuentra La en cuerda 3 (traste II)", positions: [{ string: 3, fret: 2 }], answers: ["La"] },
    ],
    professorHint:
      "En las cuerdas agudas, solo hay 5 notas naturales en la posicion I-III: Mi, Fa, Sol, La, Si, Do, Re. Memoriza su posicion.",
    professorNote:
      "El Capitulo V del metodo chileno introduce 10 ejercicios en estas cuerdas. Las melodias folkloricas chilenas habitan principalmente en este registro.",
    timeEstimate: 5,
    stringsNeeded: [1, 2, 3],
    fretRange: [0, 3],
  },
  {
    id: "ex-02",
    levelId: "explorador",
    order: 2,
    title: "Tres Cuerdas Graves",
    subtitle: "El territorio Mi-La-Re: bajos y acompañamiento (cuerdas 4-5-6)",
    category: "notas",
    difficulty: "facil",
    type: "click",
    methodRef: "Cap. VI - Notas naturales en las tres cuerdas graves (Ej. 23-30)",
    description:
      "Las cuerdas graves son el corazon del acompañamiento. Aqui viven los bajos que sostienen la armonia. Necesitas conocerlas con la misma precision que las agudas.",
    instructions: [
      "Encuentra las notas naturales en las cuerdas 4, 5 y 6.",
      "Usa digitacion con dedos fijos.",
      "Presta atencion: estas cuerdas tienen las mismas notas que las agudas pero en diferentes posiciones.",
    ],
    steps: [
      { id: 1, instruction: "Encuentra Re en cuerda 4 (al aire)", positions: [{ string: 4, fret: 0 }], answers: ["Re"] },
      { id: 2, instruction: "Encuentra Mi en cuerda 4 (traste II)", positions: [{ string: 4, fret: 2 }], answers: ["Mi"] },
      { id: 3, instruction: "Encuentra Fa en cuerda 4 (traste III)", positions: [{ string: 4, fret: 3 }], answers: ["Fa"] },
      { id: 4, instruction: "Encuentra La en cuerda 5 (al aire)", positions: [{ string: 5, fret: 0 }], answers: ["La"] },
      { id: 5, instruction: "Encuentra Si en cuerda 5 (traste II)", positions: [{ string: 5, fret: 2 }], answers: ["Si"] },
      { id: 6, instruction: "Encuentra Do en cuerda 5 (traste III)", positions: [{ string: 5, fret: 3 }], answers: ["Do"] },
      { id: 7, instruction: "Encuentra Mi en cuerda 6 (al aire)", positions: [{ string: 6, fret: 0 }], answers: ["Mi"] },
      { id: 8, instruction: "Encuentra Fa en cuerda 6 (traste I)", positions: [{ string: 6, fret: 1 }], answers: ["Fa"] },
      { id: 9, instruction: "Encuentra Sol en cuerda 6 (traste III)", positions: [{ string: 6, fret: 3 }], answers: ["Sol"] },
    ],
    professorHint:
      'Las cuerdas graves son "las bordonas". En la musica chilena, el pulgar las usa para marcar el ritmo y la armonia. Conocerlas es esencial para acompañar.',
    professorNote:
      "El Capitulo VI trabaja las bordonas. Es el complemento del V: juntos forman el mapa completo de notas naturales en la posicion I.",
    timeEstimate: 5,
    stringsNeeded: [4, 5, 6],
    fretRange: [0, 3],
  },
  {
    id: "ex-03",
    levelId: "explorador",
    order: 3,
    title: "Equisonos: El Mismo Sonido",
    subtitle: "Una nota, multiples lugares: encuentra las 3 formas de tocar la misma nota",
    category: "teoria",
    difficulty: "medio",
    type: "click",
    methodRef: "Cap. XIII - Equisonos (Ej. 56)",
    description:
      "En la guitarra, la misma nota puede tocarse en hasta 5 posiciones diferentes. Este ejercicio te entrena a ver el mastil como una red de sonidos interconectados, no como lineas aisladas.",
    instructions: [
      "Se te dara una nota.",
      "Encuentra TODAS las posiciones posibles de esa nota en el mastil.",
      "Haz clic en cada una para validar.",
    ],
    steps: [
      {
        id: 1,
        instruction: "Encuentra todas las posiciones de Mi en el mastil (hay 5)",
        positions: [
          { string: 6, fret: 0 },
          { string: 4, fret: 2 },
          { string: 1, fret: 0 },
          { string: 2, fret: 5 },
          { string: 3, fret: 9 },
        ],
        answers: ["Mi", "Mi", "Mi", "Mi", "Mi"],
        hint: "Piensa en octavas: cuerda 6 traste 0, cuerda 4 traste 2, cuerda 1 traste 0...",
      },
      {
        id: 2,
        instruction: "Encuentra todas las posiciones de Sol (hay al menos 4 visibles)",
        positions: [
          { string: 6, fret: 3 },
          { string: 3, fret: 0 },
          { string: 1, fret: 3 },
          { string: 4, fret: 5 },
        ],
        answers: ["Sol", "Sol", "Sol", "Sol"],
        hint: "Cuerda 6 traste 3, cuerda 3 al aire, cuerda 1 traste 3...",
      },
      {
        id: 3,
        instruction: "Encuentra todas las posiciones de La (hay al menos 4)",
        positions: [
          { string: 5, fret: 0 },
          { string: 3, fret: 2 },
          { string: 2, fret: 5 },
          { string: 1, fret: 5 },
        ],
        answers: ["La", "La", "La", "La"],
      },
      {
        id: 4,
        instruction: "Encuentra todas las posiciones de Re (hay al menos 4)",
        positions: [
          { string: 4, fret: 0 },
          { string: 3, fret: 7 },
          { string: 2, fret: 3 },
          { string: 1, fret: 10 },
        ],
        answers: ["Re", "Re", "Re", "Re"],
      },
    ],
    professorHint:
      'Los equisonos son la superpotencia del guitarrista. Cuando sabes que una nota existe en 5 lugares, ya no estas "buscando": estas "eligiendo la mejor posicion".',
    professorNote:
      "El Capitulo XIII del metodo chileno introduce los equisonos como concepto clave. Es lo que permite al guitarrista escalar el mastil sin perderse: siempre hay una nota equivalente cerca.",
    timeEstimate: 7,
    stringsNeeded: [1, 2, 3, 4, 5, 6],
    fretRange: [0, 12],
  },
  {
    id: "ex-04",
    levelId: "explorador",
    order: 4,
    title: "Pulgar Articulado con i-m-a",
    subtitle: "Los tres dedos de oro: indice, medio y anular trabajando juntos",
    category: "digitacion",
    difficulty: "medio",
    type: "sequence",
    methodRef: "Cap. VII - Uso del pulgar articulado con i, m y a apoyados (Ej. 31-38)",
    description:
      "El pulgar toca la melodia en las cuerdas graves mientras i, m y a permanecen apoyados en las cuerdas agudas. Es la tecnica signature del acompañamiento chileno.",
    instructions: [
      "El pulgar toca una cuerda grave (melodia).",
      "i, m, a se apoyan simultaneamente en las cuerdas agudas.",
      "Practica la coordinacion entre ambas manos.",
    ],
    steps: [
      { id: 1, instruction: "Pulgar toca cuerda 6 (Mi grave) - melodia", positions: [{ string: 6, fret: 0 }] },
      {
        id: 2,
        instruction: "i, m, a apoyan cuerdas 3, 2, 1 simultaneamente",
        positions: [{ string: 3, fret: 0 }, { string: 2, fret: 0 }, { string: 1, fret: 0 }],
      },
      { id: 3, instruction: "Pulgar toca cuerda 5 (La)", positions: [{ string: 5, fret: 0 }] },
      {
        id: 4,
        instruction: "i, m, a apoyan de nuevo en cuerdas 3, 2, 1",
        positions: [{ string: 3, fret: 0 }, { string: 2, fret: 0 }, { string: 1, fret: 0 }],
      },
      {
        id: 5,
        instruction: "Secuencia completa: 6-5-4 con apoyo de i-m-a",
        positions: [
          { string: 6, fret: 0 },
          { string: 5, fret: 0 },
          { string: 4, fret: 0 },
          { string: 3, fret: 0 },
          { string: 2, fret: 0 },
          { string: 1, fret: 0 },
        ],
      },
    ],
    professorHint:
      '"Apoyo" significa que i, m, a tocan y se quedan quietos en las cuerdas agudas. No las pulsan: las "preparan". El pulgar hace todo el trabajo ritmico.',
    professorNote:
      "El Capitulo VII tiene 8 ejercicios dedicados a esta tecnica. Es el fundamento del acompañamiento con pulgar que caracteriza la guitarra chilena.",
    timeEstimate: 6,
    stringsNeeded: [1, 2, 3, 4, 5, 6],
    fretRange: [0, 0],
  },
  {
    id: "ex-05",
    levelId: "explorador",
    order: 5,
    title: "El Mapa del Mastil",
    subtitle: "Une las cuerdas agudas y graves en un solo territorio mental",
    category: "notas",
    difficulty: "medio",
    type: "quiz",
    methodRef: "Cap. V + VI - Consolidacion",
    description:
      "Ahora que conoces las cuerdas por separado, es hora de unirlas en un solo mapa mental. Este ejercicio te fuerza a navegar entre agudas y graves sin dudar.",
    instructions: [
      "Se te preguntara por una nota sin indicar la cuerda.",
      "Elige todas las respuestas que sean posiciones validas de esa nota.",
      "Marca cada opcion correcta hasta completar el conjunto.",
    ],
    steps: [
      {
        id: 1,
        instruction: "Selecciona todas las posiciones correctas de Mi en el mastil",
        options: [
          { label: "Cuerda 6, traste 0", value: "6-0", correct: true },
          { label: "Cuerda 4, traste 2", value: "4-2", correct: true },
          { label: "Cuerda 1, traste 0", value: "1-0", correct: true },
          { label: "Cuerda 5, traste 3", value: "5-3", correct: false },
        ],
      },
      {
        id: 2,
        instruction: "Selecciona todas las posiciones correctas de La",
        options: [
          { label: "Cuerda 5, traste 0", value: "5-0", correct: true },
          { label: "Cuerda 3, traste 2", value: "3-2", correct: true },
          { label: "Cuerda 2, traste 5", value: "2-5", correct: true },
          { label: "Cuerda 6, traste 5", value: "6-5", correct: true },
        ],
      },
      {
        id: 3,
        instruction: "Selecciona todas las posiciones correctas de Sol",
        options: [
          { label: "Cuerda 6, traste 3", value: "6-3", correct: true },
          { label: "Cuerda 3, traste 0", value: "3-0", correct: true },
          { label: "Cuerda 1, traste 3", value: "1-3", correct: true },
          { label: "Cuerda 4, traste 0", value: "4-0", correct: false },
        ],
      },
    ],
    professorHint:
      'En este nivel, ya no pienses en "cuerdas" sino en "notas". El mastil es un mapa de 6 carreteras paralelas que cruzan las mismas ciudades (notas) en diferentes puntos.',
    professorNote:
      "Este es un ejercicio de consolidacion propio del gimnasio Bordona. El metodo chileno lo hace gradualmente; aqui lo aceleramos con la interactividad.",
    timeEstimate: 6,
    stringsNeeded: [1, 2, 3, 4, 5, 6],
    fretRange: [0, 5],
  },
];
